import React from 'react';
import { SwagSvgIcon } from 'swag-client-common/components/svg/swag.svg';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import classes from './powered-by-swag-link.scss';
const svgIconStyles = {
  width: '120px',
  marginLeft: '15px'
};
export class PoweredBySwagLink extends React.PureComponent {
  render() {
    const {
      color
    } = this.props;
    return /*#__PURE__*/React.createElement("a", {
      href: APP_ROUTES.HOME,
      rel: "noreferrer",
      target: "_blank",
      className: classes.root
    }, "Powered by ", /*#__PURE__*/React.createElement(SwagSvgIcon, {
      svgColor: color,
      style: svgIconStyles
    }));
  }
}